import request from '@/utils/request'

export function selectCourseList(params) {
  return request({
    url: '/api/v1.0/course/list',
    method: 'get',
    params:params
  })
}

export function selectAllCourse() {
  return request({
    url: '/api/v1.0/course/list/all',
    method: 'get',
    params:{}
  })
}

export function selectCourse(id) {
  return request({
    url: '/api/v1.0/course/'+id,
    method: 'get',
    params:{}
  })
}

export function selectCourseByNo(cno) {
  return request({
    url: '/api/v1.0/course/select',
    method: 'get',
    params:{cno:cno}
  })
}

export function addCourse(data) {
  return request({
    url: '/api/v1.0/course/add',
    method: 'post',
    data: data
  })
}

export function updateCourse(data) {
  return request({
    url: '/api/v1.0/course/update',
    method: 'post',
    data: data
  })
}

export function deleteCourse(data) {
  return request({
    url: '/api/v1.0/course/delete',
    method: 'delete',
    data: data
  })
}

// export function deleteOneCourse(params) {
//   return request({
//     url: '/deleteCourseByNo',
//     method: 'get',
//     params: params
//   })
// }

// export function deleteMultiCourse(data) {
//   return request({
//     url: '/deleteMultipleCourse',
//     method: 'post',
//     data: data
//   })
// }

